var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00481 10.8823C3.63432 10.31 4.47297 10 5.33333 10H10.6667C11.527 10 12.3657 10.31 12.9952 10.8823C13.6273 11.4569 14 12.2546 14 13.1061V14.3182C14 14.6947 13.7015 15 13.3333 15C12.9651 15 12.6667 14.6947 12.6667 14.3182V13.1061C12.6667 12.6716 12.4775 12.2361 12.1094 11.9015C11.7387 11.5645 11.2208 11.3636 10.6667 11.3636H5.33333C4.77921 11.3636 4.2613 11.5645 3.89062 11.9015C3.5225 12.2361 3.33333 12.6716 3.33333 13.1061V14.3182C3.33333 14.6947 3.03486 15 2.66667 15C2.29848 15 2 14.6947 2 14.3182V13.1061C2 12.2546 2.37273 11.4569 3.00481 10.8823Z",
    fill: "#16192C",
    stroke: "#16192C",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2.9C6.8402 2.9 5.9 3.8402 5.9 5C5.9 6.1598 6.8402 7.1 8 7.1C9.1598 7.1 10.1 6.1598 10.1 5C10.1 3.8402 9.1598 2.9 8 2.9ZM4.5 5C4.5 3.067 6.067 1.5 8 1.5C9.933 1.5 11.5 3.067 11.5 5C11.5 6.933 9.933 8.5 8 8.5C6.067 8.5 4.5 6.933 4.5 5Z",
    fill: "#16192C",
    stroke: "#16192C",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.60d29dfc12586b123077592bf5b770e4.svg";
export { ForwardRef as ReactComponent };